import React from 'react';
import { quickStats } from '../../data/populations';
import { SourceRef } from '../SourceRef';
const cellClass = ['py-6 pr-4 md:px-6 md:pl-0', 'border-l border-line py-6 pl-4 md:px-6', 'border-t border-line py-6 pr-4 md:border-l md:border-t-0 md:px-6', 'border-l border-t border-line py-6 pl-4 md:border-t-0 md:px-6'];
export function QuickStats() {
  return <section aria-label="Human digital baseline" className="border-b border-line" data-id="element-127" data-mp="l3skykpxav58">
      <dl className="mx-auto grid max-w-[1400px] grid-cols-2 px-5 md:grid-cols-4 md:px-8" data-id="element-128" data-mp="l1g4kbztcsua">
        {quickStats.map((s, i) => <div key={s.id} className={cellClass[i]} data-id="element-129" data-mp="uu3zt2b5aoqw" data-mpi={i}>
            <dt className="text-[13px] text-muted" data-id="element-130" data-mp="uux0bljigi0l">{s.label}</dt>
            <dd className="mt-1.5 font-mono text-2xl tabular text-ink" data-id="element-131" data-mp="q1uey0ow0evh">
              {s.value}
              <SourceRef id={s.sourceId} estimate={'estimate' in s ? s.estimate : undefined} data-id="element-132" data-mp="2chz4hz218k7" />
            </dd>
            <dd className="mt-0.5 font-mono text-[11.5px] text-muted" data-id="element-133" data-mp="3tit24jnmkje6">{s.detail}</dd>
          </div>)}
      </dl>
    </section>;
}